import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'descFilter'
})
export class DescFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let newVal = value;
    if (value.length > args) {
      newVal = (value.slice(0, args)).concat("...");
    }
   
    return newVal;
  }

}
